import type React from "react";
import { lazy, Suspense } from "react";
import { type RouteObject, useRoutes } from "react-router-dom";
import { Home } from "@/pages/Home";

const DevPreview = import.meta.env.DEV
	? lazy(() => import("@/pages/DevPreview").then(({ DevPreview }) => ({ default: DevPreview })))
	: null;

const routes: RouteObject[] = [
	{ path: "/", element: <Home /> },
	{ path: "/auth/callback", element: <Home /> },
	...(import.meta.env.DEV
		? ([
				{
					path: "/__preview",
					element: DevPreview ? (
						<Suspense fallback={<div role="status">正在准备预览…</div>}>
							<DevPreview />
						</Suspense>
					) : null,
				},
			] satisfies RouteObject[])
		: []),
	{ path: "*", element: <div>404 - 页面未找到</div> },
];

export const AppRoutes: React.FC = () => useRoutes(routes);
